export default __webpack_public_path__ + "static/media/Resume-SiddhantNanda.6bf83a6b.pdf";